<div class="backBackground">
    <div class="transitionEffectAll600 roundedCorner"
        [ngClass]="{'mainZero' : auth.currentUserIDSig()?.uid == null, 'mainMax' : sb.currentSidebarSize() === 'max' && auth.currentUserIDSig()?.uid != null,'mainMin' : sb.currentSidebarSize() === 'min' && auth.currentUserIDSig()?.uid != null}"
        *transloco="let t">
        <div class="page-content container-fluid base-font-color">
            <div class="row">
                <div class="col p-0 p-md-1">
                    @if (auth.currentUserIDSig()?.uid != null) {


                    @if(showSpinner || !this.auth.currentLangSig()?.lang) {
                    <div class="row">
                        <div class="col">
                            <span class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-4"></span>
                            </span>
                        </div>
                        <div class="col text-end">
                            <span class="placeholder-glow">
                                <span class="placeholder placeholder-lg bg-secondary col-4"></span>
                            </span>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col text-center">
                            <div class="svl-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    }
                    @if(!showSpinner && this.auth.currentLangSig()?.lang) {
                    <div class="page-header base-font-color d-flex justify-content-between mb-2">

                        <h2 title="{{t('budget.header-title')}}">{{t('budget.header-title')}}</h2>
                        <div class="dropdown">
                            <button class="btn btn-secondary rounded-pill dropdown-toggle" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false"
                                title="{{t('budget.button-title-select-period')}}">
                                {{t('calendar.'+this.period)}}
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" (click)="this.setPeriod(period)"
                                        *ngFor="let period of periodsShortArray; index as i;">{{t('calendar.'+period)}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-lg-3 d-none d-md-block">
                        </div>
                        <div class="col">
                            <div class="card shadow-sm" title="{{t('budget.KPI-title-total-budget')}}">

                                <div class="card-header bg-white">
                                    <b>{{t('budget.header-sum')}}</b>
                                </div>
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="height: 61px;">
                                        @if(this.loadingTotal) {
                                        <div class="w-100 text-center">
                                            <div class="svl-ripple ">
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                        } @else {
                                        <span class="display-6">
                                            {{this.totalBudget | currency: this.db.currentUserDataSig()?.currency :
                                            'symbol-narrow' }}
                                        </span>
                                        }
                                        <span class="material-symbols-outlined method-button method-blue"
                                            data-bs-toggle="modal" data-bs-target="#cloneBudgetModal"
                                            title="{{t('budget.clone-budget')}}">
                                            folder_match
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-3 d-none d-md-block"></div>
                    </div>
                    <div class="row">
                        <div class="col mx-auto">
                            <hr class="w-75 mx-auto">

                        </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2  row-cols-lg-3 row-cols-xl-4 row-gap-2 row-gap-2">
                        <div class="col" *ngFor="let category of catsArray; index as i;">
                            <div class="card"
                                title="{{t('budget.KPI-title-category-budget', { cat: category.content['name'], period: t('calendar.' + this.period) })}}">

                                <div class="card-header bg-white">
                                    {{category.content['name']}}
                                </div>
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="height: 61px;">
                                        @if(this.loadingTotal && (selectedCategory === i || allCategories)) {
                                        <div class="w-100 text-center">
                                            <div class="svl-ripple ">
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                        } @else {
                                        <span class="">

                                            <div class="display-6">
                                                {{category.content[this.period].budget | currency:
                                                this.db.currentUserDataSig()?.currency : 'symbol-narrow'}}
                                            </div>

                                        </span>
                                        }
                                        <span class="material-symbols-outlined method-button method-blue"
                                            title="{{t('budget.update-budget')}}" (click)="this.selectedCategory = i;"
                                            data-bs-toggle="modal" data-bs-target="#updateMonthlyBudgetModal">
                                            tune
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        @if(catsArray.length < maxNumberOfCategories) { <div class="col">
                            <div class="alert alert-white border-dashed d-flex">
                                <div class="col text-center" style="height: 102px;">
                                    <div class="d-flex justify-content-center align-items-center"
                                        style="height: 102px;">
                                        <span class="material-symbols-outlined method-button method-blue"
                                            data-bs-toggle="modal" data-bs-target="#newCategoryModal">
                                            add_circle
                                        </span>
                                    </div>

                                </div>
                            </div>
                    </div>
                    }
                </div>
                }
                }
                @if (auth.currentUserIDSig()?.uid == null) {
                <div class="row">
                    <div class="col">
                        <span class="placeholder-glow">
                            <span class="placeholder placeholder-lg col-4"></span>
                        </span>
                    </div>
                    <div class="col text-end">
                        <span class="placeholder-glow">
                            <span class="placeholder placeholder-lg  bg-warning col-4"></span>
                        </span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col text-center">
                        <div class="svl-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
</div>

<!-- MODALS -->

<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="updateMonthlyBudgetModal" tabindex="-1"
    aria-labelledby="updateMonthlyBudgetModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <form #updateBudgetForm="ngForm">
                <div class="modal-body">
                    <div class="row">
                        <div class="col text-end">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                title="{{t('general.button-close')}}"></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <span class="material-symbols-outlined modal-icon-grey align-content-center">
                                draw
                            </span>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-center">
                            @if(this.selectedCategory > -1 && this.catsArray) {
                            <span class="h5">{{this.catsArray[this.selectedCategory].content['name']}}</span>
                            <br>
                            <span class="display-6">{{this.catsArray[this.selectedCategory].content[this.period].budget
                                | currency: this.db.currentUserDataSig()?.currency : 'symbol-narrow'}}</span>
                            }
                            <div class="my-3 text-center">
                                @if (!this.auth.currentLangSig()?.lang) {
                                <p class="placeholder-glow">
                                    <span class="placeholder placeholder-lg col-12"></span>
                                </p>
                                }
                                @if (this.auth.currentLangSig()?.lang) {
                                <h5>{{t('budget.update')}}</h5>
                                }
                                @if(this.selectedCategory > -1) {
                                <input type="number" class="form-control" required
                                    [class.is-invalid]="value.touched && budgetModel.value < 0.01"
                                    [(ngModel)]="budgetModel.value" #value="ngModel" name="value" step="0.01" min="0"
                                    placeholder="0.00">
                                <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer px-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-4 d-grid">
                                <button class="btn btn-sm btn-link btn-link-secondary" type="button"
                                    data-bs-dismiss="modal" aria-label="Close" title="{{t('general.button-cancel')}}">
                                    {{t('general.button-cancel')}}</button>
                            </div>
                            <div class="col-8 d-grid" title="{{t('budget.update-budget')}}">
                                <button class="btn btn-sm btn-secondary rounded-pill" type="button"
                                    [disabled]="updateBudgetForm.form.invalid || budgetModel.value < 0.01"
                                    (click)="this.updateMonthlyBudget(this.budgetModel, this.catsArray[selectedCategory].id, this.period); updateBudgetForm.resetForm();"
                                    data-bs-dismiss="modal" aria-label="Close">{{t('budget.update-budget')}}</button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="cloneBudgetModal" tabindex="-1"
    aria-labelledby="updateMonthlyBudgetModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            folder_match
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">

                        <span>{{t('budget.clone-message')}}</span>


                        <div class="my-3 text-center">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col">
                                            <div class="dropdown">
                                                <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                                                    data-bs-toggle="dropdown" aria-expanded="false"
                                                    title="{{t('budget.button-title-select-clone-from-period')}}">
                                                    {{t('calendar.'+periodToCloneFrom)}}
                                                </button>
                                                <ul class="dropdown-menu">
                                                    <li><a class="dropdown-item"
                                                            (click)="this.setPeriodToCloneFrom(period)"
                                                            *ngFor="let period of fromPeriodsArray; index as i;">
                                                            {{t('calendar.'+period)}}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="d-flex justify-content-center h-100 align-items-center">
                                        <span class="material-symbols-outlined">
                                            arrow_right_alt
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row">
                                        <div class="col" title="{{t('budget.button-title-select-clone-to-period')}}">
                                            <div class="btn btn-outline-secondary disabled">
                                                {{t('calendar.'+this.period)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                                aria-label="Close" title="{{t('general.button-cancel')}}">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid" title="{{t('budget.clone-budget')}}">
                            <button class="btn btn-sm btn-secondary rounded-pill" type="button"
                                [disabled]="this.periodToCloneFrom === this.period"
                                (click)="this.cloneBudget(this.periodToCloneFrom, this.period)" data-bs-dismiss="modal"
                                aria-label="Close">{{t('budget.clone-budget')}}</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>